import { LiveInputsManagement } from '@/components/admin/live-inputs-management';
import { AdminLayout } from '@/components/layouts/admin-layout';

export default function AdminLiveInputsPage() {
  return (
    <AdminLayout>
      <LiveInputsManagement />
    </AdminLayout>
  );
}
